module.exports = __webpack_public_path__ + "media/images/down-7da89823451581e1301bb6249dad3f5f.svg";